import React from "react"
import { Modal } from "react-bootstrap"
import ImagesGallery from "../../components/ImagesGallery/ImagesGallery"

function ParcelImageModal(props) {
    return (
        <Modal
            show={props.show}
            onHide={props.viewModalClose}
            size="lg"
            dialogClassName="parcel-image-modal"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                {props.imageGallery && (
                    <ImagesGallery
                        images={props.imageGallery}
                        height={420}
                        originalClass={"imageGallery"}
                        startIndex={props.startGalleryIndex}
                    />
                )}
            </Modal.Body>
        </Modal>
    )
}

export default ParcelImageModal
